// removed by extract-text-webpack-plugin
module.exports = {"row":"NotificationsPromoCode__row__628cd0f8","description":"NotificationsPromoCode__description__628cd0f8","codeContainer":"NotificationsPromoCode__codeContainer__628cd0f8","code":"NotificationsPromoCode__code__628cd0f8 NotificationsPromoCode__description__628cd0f8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Notifications/NotificationsPromoCode.scss
// module id = ./src/components/Notifications/NotificationsPromoCode.scss
// module chunks = 4